import { render } from "./Multiselect.vue?vue&type=template&id=d4b2bd8c"
import script from "./Multiselect.vue?vue&type=script&lang=js"
export * from "./Multiselect.vue?vue&type=script&lang=js"

import "./Multiselect.vue?vue&type=style&index=0&id=d4b2bd8c&lang=css"

import exportComponent from "/home/matt/git/vue-multiselect/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__